import apiSvc from "../../services/api-service";
import { getCurrency } from "./currency-action";

export async function loadCurrency(dispatch: any) {
  apiSvc.get('SelectCurrenciesRequest').then((response) => dispatch(getCurrency(response?.data.Data)));
};
